import { Doughnut, mixins } from 'vue-chartjs'

const { reactiveProp } = mixins

/**
 * @class Doughnut
 *
 * @description This renders vue-chartjs doughnut template
 */
export default {
  extends: Doughnut,
  mixins: [reactiveProp],
  props: ['options'],
  mounted() {
    this.renderChart(this.chartData, this.options)
  },
}
